import React from 'react';
import PropTypes from 'prop-types';
import './index.css';

const SpinnerProps = {
    loading: PropTypes.bool,
    success: PropTypes.bool
};
const SpinnerDefault = {
    loading: false,
    success: false
};

export const Spinner = ({ loading, success, ...props }) => {
	return (
		<svg
            className={`spinner ${loading ? 'loading' : success ? 'success' : 'failed'}`}
			version='1.1'
			id='Layer_1'
			xmlns='http://www.w3.org/2000/svg'
			xmlnsXlink='http://www.w3.org/1999/xlink'
			x='0px'
			y='0px'
			viewBox='0 0 100 100'
			style={{ enableBackground: 'new 0 0 100 100' }}
			xmlSpace='preserve'
            preserveAspectRatio='xMidYMid meet'
            width="20"
            height="20"
			{...props}>
			<g>
				<circle className='circle' cx='50' cy='49.9999657' r='47.5' />
				<circle className='circle-dash' cx='50' cy='49.9999657' r='47.5' />
                <polyline className='cross' points='35,35 70,70' stroke='red' />
                <polyline className='cross' points='35,70 70,35' stroke='red' />
                <polyline
                    className='cross-dash'
                    points='35,35 70,70'
                    stroke='red'
                />
                <polyline
                    className='cross-dash'
                    points='35,70 70,35'
                    stroke='red'
                />
                <polyline
                    className='check'
                    points='28.6469955,52.0561066 42.2152748,65.6243896 71.3530045,36.4866562 	'
                />
                <polyline
                    className='check-dash'
                    points='28.6469955,52.0561066 42.2152748,65.6243896 71.3530045,36.4866562 	'
                />
			</g>
		</svg>
	);
};

Spinner.propTypes = SpinnerProps
Spinner.defaultProps = SpinnerDefault